// extracted by mini-css-extract-plugin
export var equalColumn = "_hs-0";